import { noteApi } from './consts';
import { tokenHeader, getUserToken } from "./user-service";

const apiEndPoint = noteApi;

export var getNotes = (prospectId) => {
    return fetch(apiEndPoint + '/' + prospectId, {
        headers: {
            [tokenHeader]: getUserToken()
        }
    })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var dateFormat = (dateStr) =>{
    let date = new Date(dateStr);
    return date.toLocaleDateString().replaceAll("/","-");;
 } 